import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { Avatar, Box, IconButton, List, ListItem, ListItemAvatar, ListItemText, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, LinearProgress, Slide, Tooltip, ListItemButton, AccordionDetails, Accordion, AccordionSummary, InputAdornment, ButtonBase, CircularProgress, Alert } from '@mui/material';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import Scrollbars from 'react-custom-scrollbars-2';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../../conf/api';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { toast } from 'react-toastify';
import ChatGPTIcon from "../../../static/icons/chat-gpt.png"
import Autocomplete from '@mui/material/Autocomplete';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function VideoPlayerDialog({ open, onClose, video }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            TransitionComponent={Transition}
        >
            <DialogTitle>
                {video?.title || "Video Player"}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box
                    sx={{
                        position: 'relative',
                        paddingTop: '56.25%', // 16:9 aspect ratio
                        backgroundColor: '#000',
                    }}
                >
                    {video?.dropbox_link ? (
                        <video
                            src={video.dropbox_link?.replace("www.dropbox.com", "dl.dropboxusercontent.com")}
                            controls
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <Typography
                            variant="h6"
                            color="text.secondary"
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                            }}
                        >
                            No video available
                        </Typography>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    );
}
function VideoDialog({ open, onClose, selectedVideos, user, handleAddVideo }) {
    const [videos, setVideos] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [videoBox, setVideoBox] = React.useState({});
    const [searchText, setSearchText] = React.useState("");

    const fetchVideos = async () => {
        setLoading(true);
        try {
            const formattedFilters = {
                user: user.username,
                dropbox: true,
                search: searchText,
            };

            const res = await api.get("/videos/api", { params: { page: 1, page_size: 1000, not_submited: 1, ...formattedFilters } });
            if (res.status === 200) {
                setVideos(res.data.results);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    React.useEffect(() => {
        fetchVideos();
        // eslint-disable-next-line
    }, [user]);

    const handleToggleSelect = (vid) => {
        const isSelected = selectedVideos.some((video) => video.id === vid.id);
        if (!isSelected) {
            handleAddVideo([...selectedVideos, vid]);
        } else {
            handleAddVideo(selectedVideos.filter((video) => video.id !== vid.id));
        }
    };
    // React.useEffect(() => { handleAddVideo(selectedVideos) }, [selectedVideos]);
    React.useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            fetchVideos();
        }, 600);

        return () => clearTimeout(debounceTimeout);

        // eslint-disable-next-line
    }, [searchText]);

    return (
        <>
            <Dialog
                TransitionComponent={Transition}
                open={open}
                onClose={() => {
                    onClose();
                    setSearchText("");
                }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Videos for {user?.first_name} {user?.last_name}</DialogTitle>
                <DialogContent>
                    {loading ? <LinearProgress /> :
                        <Box>
                            <Scrollbars style={{ height: 300 }}>
                                <List sx={{
                                    "& .Mui-selected": {
                                        bgcolor: "#73c6b6 !important",
                                    },
                                    "& .MuiListItemButton-root:hover": {
                                        "&:hover": {
                                            backgroundColor: "#a3e4d7 !important"
                                        }
                                    },

                                }}>
                                    {videos.map((item, index) => (
                                        <ListItemButton
                                            key={index}
                                            onClick={() => handleToggleSelect(item)}
                                            selected={selectedVideos.some((video) => video.id === item.id)}
                                        >
                                            <Tooltip title={"Click to play the video"} placement="top" arrow>
                                                <ListItemAvatar
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setVideoBox(item);
                                                    }}
                                                >
                                                    <Avatar>
                                                        <PlayCircleOutlineRoundedIcon color='success' />
                                                    </Avatar>
                                                </ListItemAvatar>
                                            </Tooltip>
                                            <ListItemText
                                                primary={`${item.title}`}
                                                secondary={`(${item.assert_id})-${new Date(item.created_date).toLocaleString()}`}
                                            />
                                        </ListItemButton>
                                    ))}
                                </List>
                            </Scrollbars>
                        </Box>
                    }
                    <Box>
                        {!loading && videos.length === 0 && (

                            <Typography variant="h6" color="text.secondary">No videos found</Typography>

                        )}
                        <TextField
                            fullWidth
                            label="Search Videos"
                            variant="outlined"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),

                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setSearchText("");
                        onClose();
                    }} >Close</Button>
                </DialogActions>
            </Dialog>
            <VideoPlayerDialog
                open={videoBox && Object.keys(videoBox).length > 0}
                onClose={() => setVideoBox(null)}
                video={videoBox}
            />
        </>
    );
}

export default function ActionAreaCard({ user, categories, onRemove, compilationData, setCompilationData }) {
    const [open, setOpen] = React.useState(false);

    const [loading, setLoading] = React.useState(false);
    const [formExpanded, setFormExpanded] = React.useState(true)

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleRemove = () => {
        setCompilationData(pre => {
            let preData = { ...pre };
            delete preData[user?.id];
            return preData
        })
        onRemove(user);
    }

    const handleAddVideo = (vids) => {
        setCompilationData((prev) => ({
            ...prev,
            [user?.id]: {
                ...prev[user?.id],
                videos: vids,
                errors: [],
            }
        }));
    };

    const EnhanceText = async (text) => {
        try {
            setLoading(true);
            const res = await api.post("videos/enhance-text/", { text });

            let { title, description, tags } = res.data;

            // Convert comma-separated tags into trimmed array
            let tagsArray = [];
            if (typeof tags === "string") {
                tagsArray = tags.split(",").map(tag => tag.trim()).filter(tag => tag);
            } else if (Array.isArray(tags)) {
                tagsArray = tags;
            }
            return [title, description, tagsArray];
        } catch (error) {
            console.error("Error in enhancing text:", error);
            toast.error("Error in enhancing text");
            return [null, null, []];
        } finally {
            setLoading(false);
        }
    };

    const handleAutoFill = () => {
        if (compilationData[user?.id]?.videos?.length === 0) {
            toast.error("Please select a video first");
            return;
        } else {
            let title = "";
            for (const vid of compilationData[user?.id]?.videos) {
                title += vid.title + "\n";
            }
            EnhanceText(title).then((res) => {
                if (res) {
                    setCompilationData((prev) => ({
                        ...prev,
                        [user?.id]: {
                            ...prev[user?.id],
                            question4: res[1],
                            video_title: res[0],
                            tags: res[2],
                            errors: [],
                        }
                    }));
                }
            });


        }
    }
    const is_valid = compilationData?.[user?.id]?.errors?.length === 0 ? true : false;
    return (
        <>
            <Card sx={{ width: { xs: 340, md: 440 } }}
                style={!is_valid ? {
                    boxShadow: '0 0 10px 2px red',
                    border: '1px solid red'
                } : {}}
            >
                <CardActionArea disableTouchRipple >
                    <CardContent>
                        {!is_valid &&
                            <Alert severity="error">{compilationData[user?.id]?.errors?.map(e => e)}</Alert>
                        }
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="h5" component="div">
                                {user?.first_name} {user?.last_name}
                            </Typography>
                            <IconButton onClick={(e) => {
                                e.stopPropagation();
                                handleRemove();
                            }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {user?.username}
                            <br />
                            {user?.email}
                        </Typography>
                        <Typography variant='subtitle1' mt={1}>Selected Videos</Typography>
                        <Box border={"1px solid #ccc"} borderRadius={2} padding={1} component={ButtonBase} width="100%" display="flex" onClick={handleOpen}>
                            <Scrollbars style={{ height: compilationData[user?.id]?.videos?.length === 0 ? 90 : 200 }}>
                                <List dense sx={{ padding: 0 }}>
                                    {compilationData[user?.id]?.videos?.map((item, index) => (
                                        <ListItem key={index}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <PlayCircleOutlineRoundedIcon fontSize='small' color='success' />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText primary={`${item.title}`} secondary={`(${item.assert_id}) ${new Date(item.created_date).toLocaleString()}`} />
                                        </ListItem>
                                    ))}
                                    {compilationData[user?.id]?.videos?.length === 0 && (
                                        <ListItem>
                                            <ListItemText primary="No videos added" secondary="Click to add videos" />
                                        </ListItem>
                                    )}
                                </List>
                            </Scrollbars>
                        </Box>
                        <Box mt={2}>
                            <Accordion expanded={formExpanded} onChange={() => setFormExpanded(!formExpanded)} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    id="video_details-header"
                                    onClick={e => e.stopPropagation()}
                                >
                                    <Box display="flex" alignItems="center">
                                        <Tooltip title="Auto fill" placement="top" arrow>
                                            <IconButton
                                                color='success'
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setFormExpanded(true);
                                                    handleAutoFill();
                                                }}>
                                                {loading ?
                                                    <CircularProgress size={23} />
                                                    :
                                                    <Box component="img" src={ChatGPTIcon} width={25} />
                                                }
                                            </IconButton>
                                        </Tooltip>
                                        <Typography component="span">Video Infomation</Typography>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails sx={{ pt: 0, mt: -2 }}>
                                    <Box component="form" noValidate autoComplete="off">
                                        <TextField
                                            disabled={loading}
                                            value={compilationData?.[user?.id]?.video_title || ""}
                                            onChange={(e) => setCompilationData((prev) => ({ ...prev, [user?.id]: { ...prev[user?.id], video_title: e.target.value } }))}
                                            fullWidth
                                            label="Compiled Videos Title"
                                            name="video_title"
                                            placeholder="Compiled Videos Title"
                                            variant="outlined"
                                            margin="dense"
                                            size='small'
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="start">
                                                        {loading && <CircularProgress size={20} />}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        <TextField
                                            disabled={loading}
                                            value={compilationData?.[user?.id]?.question4 || ""}
                                            onChange={(e) => setCompilationData((prev) => ({ ...prev, [user?.id]: { ...prev[user?.id], question4: e.target.value } }))}
                                            multiline
                                            fullWidth
                                            placeholder={
                                                "Please provide a background story/context for the video."
                                            }
                                            name="question4"
                                            margin="dense"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="start">
                                                        {loading && <CircularProgress size={20} />}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        <Autocomplete
                                            options={categories}
                                            getOptionLabel={(option) => option.title}
                                            value={compilationData?.[user?.id]?.category || null}
                                            onChange={(event, newValue) => {
                                                setCompilationData((prev) => ({
                                                    ...prev,
                                                    [user?.id]: {
                                                        ...prev[user?.id],
                                                        category: newValue,
                                                    },
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Category"
                                                    placeholder="Choose a category"
                                                    variant="outlined"
                                                    margin="dense"
                                                    size="small"

                                                />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                        />
                                        <Autocomplete
                                            multiple
                                            freeSolo
                                            options={[]}
                                            value={compilationData?.[user?.id]?.tags || []}
                                            onChange={(event, newValue) => {
                                                console.log(newValue);
                                                setCompilationData((prev) => ({
                                                    ...prev,
                                                    [user?.id]: {
                                                        ...prev[user?.id],
                                                        tags: newValue,
                                                    },
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Add Tags"
                                                    placeholder="Type or select tags"
                                                    variant="outlined"
                                                    margin="dense"
                                                    size="small"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                {loading && <CircularProgress size={20} />}
                                                            </InputAdornment>
                                                        ),
                                                        ...params.InputProps,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Box>
                                </AccordionDetails>
                            </Accordion>

                        </Box>

                    </CardContent>

                </CardActionArea >
            </Card >

            <VideoDialog
                open={open}
                onClose={handleClose}
                user={user}
                selectedVideos={compilationData[user?.id].videos}
                handleAddVideo={handleAddVideo}
            />
        </>
    );
}